// useLicenseState — SWR hook for GET /api/v1/license/state (T191).
import useSWR from 'swr';
import { fetcher } from './api';

export type LicenseTier = 'grace' | 'expired' | 'trial' | 'enterprise';

export interface LicenseState {
  tier: LicenseTier;
  days_remaining: number; // -1 when no expiry
  installed_at: string;   // RFC3339
  expires_at?: string;    // RFC3339, omitted when not applicable
  /** T365: resolved license.FeatureSet, sorted. Empty for a community org. */
  features: string[];
}

const LICENSE_STATE_URL = '/api/v1/license/state';

export function useLicenseState() {
  const { data, error } = useSWR<LicenseState>(LICENSE_STATE_URL, fetcher, {
    refreshInterval: 5 * 60 * 1000, // re-check every 5 minutes
    revalidateOnFocus: false,
  });
  return {
    state: data ?? null,
    isExpired: data?.tier === 'expired',
    loading: !data && !error,
    /** Whether `feature` is present in the org's resolved FeatureSet.
     *  False (not a false-positive lock) while `loading` is still true —
     *  callers gating a whole page should check `loading` first. */
    hasFeature: (feature: string) => (data?.features ?? []).includes(feature),
  };
}
